import { registerPlugin } from "@capacitor/core";
import { CalendarChooserDisplayStyle } from "./schemas/enums/calendar-chooser-display-style";
import { CalendarChooserSelectionStyle } from "./schemas/enums/calendar-chooser-selection-style";
import { PluginPermission } from "./schemas/enums/plugin-permission";
import { ReminderRecurrenceFrequency } from "./schemas/enums/reminder-recurrence-frequency";
import { EventSpan } from "./schemas/enums/event-span";
import { CalendarSourceType } from "./schemas/enums/calendar-source-type";
import { CalendarType } from "./schemas/enums/calendar-type";
const CapacitorCalendar = registerPlugin("CapacitorCalendar", {
    web: () => import("./web").then((m) => new m.CapacitorCalendarWeb()),
});
export * from "./definitions";
export { CalendarChooserSelectionStyle, CalendarChooserDisplayStyle, PluginPermission, ReminderRecurrenceFrequency, EventSpan, CalendarSourceType, CalendarType, CapacitorCalendar, };
//# sourceMappingURL=index.js.map